import Vue from "vue";
import {
  Toast
} from 'vant';
import apis from "@/config/api.config.js"
import qs from "qs";

export default {
  name: "regist",
  data() {

    return {
      school_v: '',
      grade_v: '',
      relationship_v: '',
      stuname: '',
      parname: '',
      phone: '',
      showSchool: false,
      showGrade: false,
      showRelationship: false,
      areaList: {}, // 数据格式见 Area 组件文档
      school: [],
      grade: [],
      relationship: [
        "父亲", "母亲"
      ],
      pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/,// 电话匹配
      valueable: false,
      value1: -1,
      value2: '',
      option1_title: '点击选择就读学校',
      option1: [{
          text: '学校0',
          value: 0,
          show: 1
        },
        {
          text: '学校1',
          value: 1,
          show: 1
        },
      ],
      value11: 0,
      option1: [
        { text: '全部商品', value: 0 },
        { text: '新款商品', value: 1 },
        { text: '活动商品', value: 2 },
      ],
    };
  },
  watch:{
      school_v(nv,ov){
        console.log(ov == '');
        if (ov != '') {
          console.log(111);
          
          this.grade_v = '';
        }
      },
  },
  methods: {
    triggerGrade(){
      const that = this;
      
      if (that.school_v.length) {
        that.showGrade = true;
      }
      else{
        Toast("请先选择就读学校！")
      }
  
    },
    onChange(e) {
      // console.log(e);
      // if (this.value == 2) {
      //   this.valueable = false
      // } else {
      //   this.valueable = true
      // }
    },
    onConfirm(index) {
      this.value1 = index;
      this.option1_title = this.option1[index].text;
      this.school_v = this.option1[index].text;

      // console.log(this.school[index]);
      this.onConfirm_school(this.school[index])
      this.$refs.item.toggle();
    },
    onSearch(val) {
      Toast(val);
    },
    onCancel() {
      // Toast('取消');
      this.$refs.item.toggle();
    },
    onInput(val) {
      // console.log(val);
      for (let i = 0; i < this.option1.length; i++) {
        if (this.option1[i].text.indexOf(val) == -1) {
          this.option1[i].show = 0;
        } else {
          this.option1[i].show = 1;
        }
      }
    },
    onSubmit(values) {
      const that = this;
      console.log('submit', values);
      let departmentid;
      let gradeid;
      let classnum;
      for(let i = 0; i < that.school.length; i++) {
        if(values['school']==that.school[i]['text']) {
          departmentid = that.school[i]['id']
          for (let j = 0; j < that.school[i].grade.length; j++) {
            if (values['grade'].split(' ')[0] == that.school[i].grade[j]['text']) {
              gradeid = that.school[i].grade[j].id
              classnum = values['grade'].split(' ')[1].replace("班","")
            }
            
          }
        }
      }
      
      
      let toast = Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '提交中',
      });
      let post_data = {
        departmentid,
        gradeid,
        classnum,
        name:that.stuname,
        parname:that.parname,
        parrel:that.relationship_v,
        mobile:that.phone,
        device: localStorage.getItem("luoohutoken"),
        type: 1,
      };
      that
        .axios({
          method: "post",
          // headers: { "Content-Type": "application/x-www-form-urlencoded" },
          // url: apis.getActivityList,
          url: apis.addInfo,
          data: qs.stringify(post_data),
        })
        .then((res) => {
          Toast.clear();// 清除所有弹框
          res = res.data;
          Toast({
            duration: 2000, // 持续展示 toast
            forbidClick: true,
            message: res.msg,
            onClose:function () {
              that.$router.replace('/game')
              // if (res.data.code == 200) {
              //   this.$router.replace('/game')

              // }
              
            }
          });
          
          
          

        })
        .catch((rej) => {
          console.log(rej);
        });
    },
    onConfirm_school(values) {


      this.school_v = values['text'];

      this.grade = values['grade']
      // console.log(values);

      this.showSchool = false;
    },
    onConfirm_grade(values) {
      values[1] = values[1] + '班'
      this.grade_v = values
        //   .filter((item) => !!item)
        //   .map((item) => item.name)
        .join(' ');

      // console.log(values);

      this.showGrade = false;
    },
    onConfirm_relationship(values) {
      this.relationship_v = values
      // console.log(values);
      this.showRelationship = false;
    },
    getDepartmentList() {
      const that = this;
      let toast = Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '提交中',
      });
      let post_data = {
        activity_id: that.id
      };
      that
        .axios({
          method: "post",
          // headers: { "Content-Type": "application/x-www-form-urlencoded" },
          // url: apis.getActivityList,
          url: apis.getDepartmentList,
          data: qs.stringify(post_data),
        })
        .then((res) => {
          // console.log(res);

          Toast.clear();// 清除所有弹框
          res = res.data;
          if (res.status == 200) {
            // console.log(res.msg);

            that.option1 = [];
            // for (let i = 0; i < res.msg.length; i++) {
            //   const element = res.data[i];
            //   that.option1.push({
            //     text: res.msg[i]['name'],
            //     value: i,
            //     show: 1,
            //     id: res.msg[i]['id'],
            //   })

            // }
            // console.log(that.option1);
            // let columns = [];
            let school = [];
            for (let i = 0; i < res.msg.length; i++) {
              that.option1.push({
                text: res.msg[i]['name'],
                value: i,
                show: 1,
                id: res.msg[i]['id'],
              })
              school.push(
                {
                  text: res.msg[i]['name'],
                  id: res.msg[i]['id'],
                  grade: []
                }
              )
              for (let j = 0; j < res.msg[i]['grades'].length; j++) {
                let grades = res.msg[i]['grades'][j]
                let itemson = {
                  text: grades['name'],
                  id: grades['id'],
                  children: []
                }
                school[i].grade.push(itemson)
                // console.log(item);
                for (let k = 0; k < grades['class_count']; k++) {
                  // console.log(school,grades,k+1);
                  let itemgrandson = {
                    text: k + 1
                  }
                  itemson.children.push(itemgrandson)
                  // console.log(itemgrandson);

                }
              }

            }

            console.log(school);
            that.school = school;

          }
        })
        .catch((rej) => {
          console.log(rej);
        });
    },
  },
  created() {
    const that = this;
    // that.id = that.$route.query.id;
    // that.type = that.$route.query.type;
  },
  mounted() {
    const that = this;

    that.getDepartmentList();


    // if (that.type == 0) {
    //   that.hasIdentify = true;
    //   that.getQuestions()
    // } else {
    //   that.checkUserId();

    //   that.getIdList();
    // }

  },
};